'use client'

import { RulerIcon } from 'lucide-react'
import React from 'react'

import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import type { SizeChart } from '@/payload-types'

const VALUE_KEYS = ['v1', 'v2', 'v3', 'v4', 'v5'] as const

/** Кнопка «Таблица размеров» и модалка с таблицей замеров. */
export const SizeChartDialog: React.FC<{ chart: SizeChart }> = ({ chart }) => {
  const columns = (chart.columns ?? []).map((c) => c.label)
  const rows = chart.rows ?? []
  if (columns.length === 0 || rows.length === 0) return null

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="link" className="self-start px-0 h-auto text-sm text-ink/70 hover:text-punch">
          <RulerIcon className="w-4 h-4 mr-1" />
          Таблица размеров
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Таблица размеров</DialogTitle>
          <DialogDescription>Замеры изделия в сантиметрах.</DialogDescription>
        </DialogHeader>
        <div className="overflow-x-auto -mx-6 px-6">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 pr-4 font-medium">Размер</th>
                {columns.map((label, i) => (
                  <th key={i} className="text-left py-2 pr-4 font-medium whitespace-nowrap">
                    {label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={row.id ?? i} className="border-b last:border-0">
                  <td className="py-2 pr-4 font-mono">{row.size}</td>
                  {columns.map((_, ci) => (
                    <td key={ci} className="py-2 pr-4">
                      {row[VALUE_KEYS[ci]!] ?? '—'}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {chart.note && <p className="text-sm text-primary/70 whitespace-pre-line">{chart.note}</p>}
      </DialogContent>
    </Dialog>
  )
}
